import { useEffect } from "react";
import { useLocation, useMatches } from "react-router-dom";
import { awsRum } from "../rum/cloudwatchRum";
import { isRouteHandle } from "../utils/route.util";

/**
 * Hook that automatically tracks page views in RUM.
 * Must be used inside a Router context.
 */
export function useRumPageTracker() {
  const location = useLocation();
  const matches = useMatches();

  useEffect(() => {
    const pathname = location.pathname;
    const handle = matches.at(-1)?.handle;
    if (isRouteHandle(handle)) {
      awsRum?.recordPageView({ pageId: handle.pageId });
      return;
    }
    awsRum?.recordError({ message: `No pageId found for path: ${pathname}` });
    awsRum?.recordPageView({ pageId: "unknown" });
  }, [location.pathname, matches]);
}
